export function isMapAutoPaginateBlockedByCursorRecovery(input: {
  readonly isError: boolean;
  readonly isFetching: boolean;
  readonly recoveryAttemptedForCurrentKey: boolean;
}): boolean {
  return input.isError || input.isFetching || input.recoveryAttemptedForCurrentKey;
}
